import { TEXT } from '../../../helpers';

export const SearchBarTextConst = {
	projects: `/${TEXT.projects}`,
};
